import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
// Use both Authorization and X-Auth-Token — some network proxies strip Authorization header
api.interceptors.request.use(config => {
  const token = localStorage.getItem('ucc_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers['X-Auth-Token'] = token; // fallback if proxy strips Authorization
  }
  return config;
});

// Handle 401 — only logout if the auth session itself is invalid.
// Do NOT redirect on 401s from regular API calls (members, attendance, etc.)
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      const url = err.config?.url || '';
      const errMsg = err.response?.data?.error || '';
      const isAuthEndpoint = url.includes('/auth/me') || url.includes('/auth/verify');
      const isTokenInvalid = errMsg.includes('expired') || errMsg.includes('Invalid authentication');
      if (isAuthEndpoint || isTokenInvalid) {
        localStorage.removeItem('ucc_token');
        localStorage.removeItem('ucc_member');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;

// ─── Offline queue for failed requests ─────────────────
const offlineQueue = [];
let isProcessingQueue = false;

export function queueOfflineRequest(request) {
  offlineQueue.push(request);
}

async function processOfflineQueue() {
  if (isProcessingQueue || offlineQueue.length === 0) return;
  isProcessingQueue = true;
  while (offlineQueue.length > 0) {
    const req = offlineQueue.shift();
    try {
      await api(req);
    } catch (e) {
      // Failed again - discard
    }
  }
  isProcessingQueue = false;
}

window.addEventListener('online', processOfflineQueue);
